<script setup lang="ts">
// Campo-cartão do Minha Conta V2 (ENG-362): borda arredondada, label pequeno
// em cima, valor embaixo e ícone de ação à direita (componente "Input" do
// Figma, node 2933:40407). Compartilhado entre as telas "Login e segurança"
// e "Dados da conta".
interface Props {
  label: string;
  value: string;
  icon?: 'edit' | 'eye' | 'lock';
}

const props = defineProps<Props>();

const emit = defineEmits<{ click: [] }>();

// Ícones de traço 1.5 no mesmo estilo do UserV2Icon (viewBox 24x24).
const iconPaths: Record<NonNullable<Props['icon']>, string> = {
  edit: 'M11 5H6a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2v-5m-1.5-9.5a2.121 2.121 0 1 1 3 3L12 16l-4 1 1-4 8.5-8.5Z',
  eye: 'M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12Zm12.5 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z',
  lock: 'M7 11V8a5 5 0 0 1 10 0v3M5 11h14v10H5V11Zm7 4v3',
};
</script>

<template>
  <button
    class="flex min-h-[48px] w-full items-center rounded-[12px] border-2 border-v2-default-500 bg-v2-default-300 px-[6px] py-[4px] text-left shadow-[0px_1px_1px_rgba(0,0,0,0.05)]"
    type="button"
    @click="emit('click')"
  >
    <span class="flex min-w-0 flex-1 flex-col justify-center px-[6px] pb-[2px]">
      <span class="truncate text-[12px] leading-[16px] text-v2-default-700">
        {{ props.label }}
      </span>
      <span class="truncate text-[14px] leading-[20px] text-v2-foreground">
        {{ props.value }}
      </span>
    </span>
    <svg
      v-if="props.icon"
      class="mr-[6px] size-[20px] shrink-0 text-v2-default-700"
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
      viewBox="0 0 24 24"
    >
      <path :d="iconPaths[props.icon]" />
    </svg>
  </button>
</template>
